import React from "react";
import Tippy from "@tippy.js/react";
import "tippy.js/dist/tippy.css";

/**
 * JobSeekerTooltip - A reusable tooltip component for Job Seeker pages
 * @param {React.ReactNode} children - The element that triggers the tooltip
 * @param {string} content - The tooltip content/text
 * @param {string} placement - Tooltip placement (top, bottom, left, right)
 * @param {object} props - Additional Tippy props
 */
const JobSeekerTooltip = ({ children, content, placement = "top", ...props }) => {
  if (!content) {
    return children;
  }

  return (
    <Tippy
      content={content}
      placement={placement}
      arrow={true}
      delay={[200, 0]}
      duration={[200, 150]}
      className="bg-gray-800 text-white text-sm px-2 py-1 rounded shadow-lg"
      {...props}
    >
      {children}
    </Tippy>
  );
};

export default JobSeekerTooltip;

